/* global */
/**
 * Klaviyo documentation gate.
 * Each [data-doc-gate] holds a Klaviyo embed form and a JSON list of files
 * (from the pagina_fabricante metaobject). On successful Klaviyo form submit,
 * fetch every file, pack into a single .zip and download it.
 */
(function () {
  'use strict';

  var JSZIP_SRC =
    'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
  var jszipPromise = null;

  function loadJSZip() {
    if (window.JSZip) {
      return Promise.resolve(window.JSZip);
    }
    if (jszipPromise) {
      return jszipPromise;
    }
    jszipPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = JSZIP_SRC;
      s.async = true;
      s.onload = function () {
        window.JSZip ? resolve(window.JSZip) : reject(new Error('JSZip missing'));
      };
      s.onerror = function () {
        reject(new Error('JSZip failed to load'));
      };
      document.head.appendChild(s);
    });
    return jszipPromise;
  }

  function parseFiles(gate) {
    var tag = gate.querySelector('script[data-doc-files]');
    if (!tag) return [];
    try {
      var list = JSON.parse(tag.textContent || '[]');
      return Array.isArray(list) ? list.filter(function (f) { return f && f.url; }) : [];
    } catch (e) {
      return [];
    }
  }

  function uniqueName(used, name, index) {
    var base = name || 'archivo-' + (index + 1);
    var n = base;
    var i = 1;
    while (used[n]) {
      var dot = base.lastIndexOf('.');
      n = dot > 0
        ? base.slice(0, dot) + '-' + i + base.slice(dot)
        : base + '-' + i;
      i++;
    }
    used[n] = true;
    return n;
  }

  function triggerDownload(blob, fileName) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }

  function revealFallback(gate) {
    var fb = gate.querySelector('[data-doc-fallback]');
    if (fb) fb.hidden = false;
  }

  function buildZip(gate) {
    if (gate.getAttribute('data-doc-done') === 'true') return;
    gate.setAttribute('data-doc-done', 'true');

    var files = parseFiles(gate);
    if (!files.length) {
      revealFallback(gate);
      return;
    }

    var zipName = gate.getAttribute('data-zip-name') || 'documentacion';
    gate.setAttribute('data-doc-state', 'loading');

    loadJSZip()
      .then(function (JSZip) {
        var zip = new JSZip();
        var folder = zip.folder(zipName);
        var used = {};
        var ok = 0;

        var jobs = files.map(function (f, idx) {
          return fetch(f.url, { mode: 'cors' })
            .then(function (r) {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.blob();
            })
            .then(function (blob) {
              folder.file(uniqueName(used, f.name, idx), blob);
              ok++;
            })
            .catch(function () {
              /* skip unreachable file, keep going */
            });
        });

        return Promise.all(jobs).then(function () {
          if (!ok) {
            revealFallback(gate);
            gate.setAttribute('data-doc-state', 'error');
            return;
          }
          return zip
            .generateAsync({ type: 'blob' })
            .then(function (content) {
              triggerDownload(content, zipName + '.zip');
              gate.setAttribute('data-doc-state', 'done');
              if (ok < files.length) revealFallback(gate);
            });
        });
      })
      .catch(function () {
        // JSZip unavailable — degrade to individual links.
        gate.setAttribute('data-doc-state', 'error');
        revealFallback(gate);
      });
  }

  function gateForForm(formId) {
    if (!formId) return null;
    return document.querySelector(
      '[data-doc-gate][data-klaviyo-form-id="' + formId + '"]'
    );
  }

  // Klaviyo dispatches `klaviyoForms` events on document.
  document.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail) return;
    if (e.detail.type !== 'submit') return;
    var gate = gateForForm(e.detail.formId);
    if (gate) buildZip(gate);
  });
})();
